var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import FileUpload from "~/components/common/file-upload.vue";
import { Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import { ApprovalExportManageService } from '~/services/dataimp-service/approval-export-manage.service.ts';
var PaymentFileUpload = /** @class */ (function (_super) {
    __extends(PaymentFileUpload, _super);
    function PaymentFileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.submitLoading = false;
        _this.model = {
            fileId: "",
        };
        return _this;
    }
    PaymentFileUpload.prototype.onUploadSuccess = function (id, data) {
        this.model.fileId = data.id;
    };
    PaymentFileUpload.prototype.submit = function () {
        var _this = this;
        if (this.fileList.length === 0) {
            this.$message("请上传文件");
            return;
        }
        this.submitLoading = true;
        this.approvalExportManageService.importPaymentCheck(this.model.fileId).subscribe(function (data) {
            _this.$message.success("导入成功!");
            _this.success();
            _this.submitLoading = false;
        }, function (err) { return (_this.submitLoading = false); });
    };
    PaymentFileUpload.prototype.close = function () {
        this.reset();
    };
    PaymentFileUpload.prototype.success = function () {
        this.close();
    };
    PaymentFileUpload.prototype.reset = function () {
        var fileupload = this.$refs["file-upload"];
        fileupload.reset();
    };
    __decorate([
        Dependencies(ApprovalExportManageService)
    ], PaymentFileUpload.prototype, "approvalExportManageService", void 0);
    __decorate([
        Emit()
    ], PaymentFileUpload.prototype, "close", null);
    __decorate([
        Emit()
    ], PaymentFileUpload.prototype, "success", null);
    PaymentFileUpload = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], PaymentFileUpload);
    return PaymentFileUpload;
}(Vue));
export default PaymentFileUpload;
